module.exports = __webpack_public_path__ + "img/for-kids-5.d4395c8.webp";